import { FC, memo } from 'react'
import { Text, VStack } from '../index'

export interface PhoneSpecsCondensedProps {
  name: string
  brand: string
}

export const PhoneSpecsCondensed: FC<PhoneSpecsCondensedProps> = memo(({ name, brand }) => (
  <VStack fontSize="sm" alignItems="flex-start" spacing={1} marginTop={'-5px'}>
    <Text fontWeight="700" fontSize="xs">
      {name}
    </Text>
    <Text fontSize="xxs" color="darkgray" fontWeight="bold">
      {brand}
    </Text>
  </VStack>
))
